export default __webpack_public_path__ + "static/media/kajabi_logo.7309534f.png";